import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ImpressumPage = () => {
    const { t } = useTranslation();
    const s = {
        container: { padding: '20px', color: '#aaa', maxWidth: '600px', margin: '0 auto' },
        backLink: { color: '#007BFF', textDecoration: 'none', fontSize: '1.2em' }
    };
    return (
        <div style={s.container}>
                <Link to="/" style={s.backLink}>{t('impressum_back_to_map', '← Zurück zur Karte')}</Link>
                <h1>{t('impressum_title', 'Impressum')}</h1>
                <p>{t('impressum_info_5_tmg', 'Angaben gemäß § 5 TMG')}</p>
                <p><strong>{t('impressum_name_firma', 'Thomas Schmid')}</strong><br/>{t('impressum_strasse_nr', 'Musterstraße 1')}<br/>{t('impressum_plz_stadt', '12345 Musterstadt')}<br/>{t('impressum_country', 'Deutschland')}</p>
                <h2>{t('impressum_contact', 'Kontakt')}</h2>
                <p>{t('impressum_email', 'E-Mail: info@example.com')}</p>
                <h2>{t('impressum_disclaimer_title', 'Haftungsausschluss')}</h2 >
                <p>{t('impressum_disclaimer_text', 'Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt...')}</p>
        </div>
    );
};
export default ImpressumPage;
